import { useTranslation } from 'react-i18next';

import { formatCpm, formatImpressions, formatSpend } from '../../model/format';

interface MetricCardsProps {
  kpis: { spend: number; impressions: number; cpm: number };
  /** Scope line repeated on each card, e.g. "All brands · Sep 2025 – Nov 2025". */
  meta: string;
}

export const MetricCards = ({ kpis, meta }: MetricCardsProps) => {
  const { t } = useTranslation('analysis');

  const cards = [
    { label: t('analysisResult.mediaLandscape.totalSpend'), value: formatSpend(kpis.spend) },
    {
      label: t('analysisResult.mediaLandscape.impressions'),
      value: formatImpressions(kpis.impressions),
    },
    { label: t('analysisResult.mediaLandscape.avgCpm'), value: formatCpm(kpis.cpm) },
  ];

  return (
    <div className="grid grid-cols-1 items-stretch gap-4 sm:grid-cols-3">
      {cards.map((card) => (
        <div
          key={card.label}
          className="flex flex-col gap-2 rounded-lg border border-border-light bg-card p-5"
        >
          <span className="text-sm text-muted-foreground">{card.label}</span>
          <span className="text-[32px] font-medium leading-10 -tracking-[0.01em] text-foreground">
            {card.value}
          </span>
          <span className="text-xs text-muted-foreground">{meta}</span>
        </div>
      ))}
    </div>
  );
};
